// Autorise lettres (accents inclus), espaces, apostrophes et tirets
export const sanitizeNameInput = (value) =>
    value.replace(/[^a-zA-ZÀ-ÖØ-öø-ÿ\s'-]/g, '');

// Autorise lettres, chiffres, @, ., _ et - (nécessaires pour une adresse email valide)
export const sanitizeEmailInput = (value) =>
    value.replace(/[^a-zA-Z0-9@._-]/g, '');